import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-count',
  templateUrl: './stock-count.component.html',
  styleUrls: ['./stock-count.component.css']
})
export class StockCountComponent implements OnInit {
    stockPlaceId;

    stockCountKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
        this.stockCountKeyno = this.stateService.getStateParams()['stockcount_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockPlaceId && !!this.stockCountKeyno) {
            this.edit = (await this.datatask.Post(953, {
                stockplace_id: this.stockPlaceId,
                stockcount_keyno: this.stockCountKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(954, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockcount_keyno: string;
    stockplace_name: string;
    approved: string;
    stockcount_date: string;
    approved_date: string;
    stockcount_name: string;
    show_setting: string;
    reg_by_portal_user_name: string;
    approved_by_portal_user_name: string;
    stockplace_id: string;
    stockcount_status: string;
}
